import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Aug 22 2018
 * @author BPo
 */
import { Utils } from '@logio/common-be-fe';
import * as React from 'react';
import { FormSpy } from 'react-final-form';
import { FormContextConsumer } from '../Form/FormContext';
/**
 * This component is useful if you need to get options (parsed lookup response).
 * For example, you can use the `OptionsProvider` component if you want to render
 * a static listing of lookup values. Or you can render multiple `Field`s based
 * on options from another field.
 */

var OptionsProviderComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OptionsProviderComponent, _React$Component);

  function OptionsProviderComponent() {
    var _this;

    _classCallCheck(this, OptionsProviderComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptionsProviderComponent).apply(this, arguments));
    _this.state = {
      loading: true
    };
    return _this;
  }
  /**
   * Returns passed component with given options.
   */


  _createClass(OptionsProviderComponent, [{
    key: "getComponent",
    value: function getComponent() {
      if (this.state.selectOptions) {
        return this.props.component(this.state.selectOptions);
      }

      var options;
      var description = this.props.formContext.descriptions[this.props.name];

      if (!Utils.isValueMissing(description)) {
        options = this.props.formContext.formStore.getOptions(description);
      }

      return this.props.component(options);
    }
    /**
     * Update component when loading state is set or values changed.
     */

  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      // Just re-render the UI
      if (this.state.loading === true && nextState.loading === false) {
        return true;
      } // Load new lookups if needed


      return this.doesValuesChanged(nextProps);
    }
    /**
     * Compares depending values.
     */

  }, {
    key: "doesValuesChanged",
    value: function doesValuesChanged(nextProps) {
      var _this2 = this;

      var shouldUpdate = false;

      if (this.props.values !== nextProps.values) {
        /** Checks value changes for dependsOnValue */
        if (Utils.isObject(this.props.requiredFieldValue)) {
          Object.entries(this.props.requiredFieldValue).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                fieldName = _ref2[0],
                required = _ref2[1];

            if (required && _this2.props.values[fieldName] !== nextProps.values[fieldName]) {
              shouldUpdate = true;
            }
          });
        }
        /** Checks value changes for dependsOn fields */


        if (Utils.isObject(this.props.dependsOn)) {
          Object.values(this.props.dependsOn).forEach(function (fieldName) {
            var fieldNameArray = Utils.isArray(fieldName) ? fieldName : [fieldName];
            /**
             * Checks field value for change
             * @param f
             */

            var valueValidation = function valueValidation(f) {
              if (_this2.props.values[f] !== nextProps.values[f]) {
                shouldUpdate = true;
              }
            };

            fieldNameArray.forEach(function (f) {
              return valueValidation(f);
            });
          });
        }
      }

      return shouldUpdate;
    }
    /**
     * Loads options when values change
     */

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.doesValuesChanged(nextProps)) {
        this.loadOptions(nextProps.values);
      }
    }
    /**
     * Loads options on first render
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadOptions();
    }
    /**
     * Gets all dependent values
     */

  }, {
    key: "getDependentItems",
    value: function getDependentItems() {
      var _this3 = this;

      var valuesArg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.values;
      var values = {};

      if (this.props.dependsOn) {
        Object.keys(this.props.dependsOn).forEach(function (key) {
          var fieldName = _this3.props.dependsOn[key];

          if (Utils.isArray(fieldName)) {
            /**
             * <>
             *    Finds first changed field value and returns it under this key.
             *    Doesn't cover all possible scenarios. Covers only dependsOn with one key. It has limited number of use cases.
             * </>
             */
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = fieldName[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var f = _step.value;
                var value = valuesArg[f];
                var valueMissing = Utils.isValueMissing(value);
                var valueDiff = _this3.props.values[f] !== value;

                if (!valueMissing && valueDiff) {
                  values[key] = value;
                  break;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          } else {
            var _value = valuesArg[fieldName];

            if (!Utils.isValueMissing(_value)) {
              values[key] = _value;
            }
          }
        });
      }

      return values;
    }
    /**
     * Loads dependent options. Use wisely, you may cause re-render loop.
     */

  }, {
    key: "loadOptions",
    value: function loadOptions() {
      var _this4 = this;

      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.values;

      /** Dependent field value check */
      if (Utils.isObject(this.props.requiredFieldValue)) {
        var foundEmptyFieldValue = Object.entries(this.props.requiredFieldValue).some(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              fieldName = _ref4[0],
              dependent = _ref4[1];

          var value = values[fieldName];
          return dependent === true && (!value || Utils.isArray(value) && value.length === 0);
        });

        if (foundEmptyFieldValue) {
          var selectOptions = {
            options: [],
            filterOptions: function filterOptions(value) {
              return [];
            }
          };
          this.setState({
            loading: false,
            selectOptions: selectOptions
          });
          return;
        }
      }

      var dependentItems = this.getDependentItems(values);
      var dependsOnProp = Utils.isObject(this.props.dependsOn) && !Utils.isEmptyObject(dependentItems);
      var dependsOnDiff = dependsOnProp && Object.keys(this.props.dependsOn).length !== Object.keys(dependentItems).length;
      /** Empty or Different dependent fields check */

      if (!dependsOnProp || dependsOnDiff) {
        if (this.state.loading) {
          this.setState({
            loading: false
          });
        }

        return;
      }

      this.setState({
        loading: true
      }, function () {
        _this4.props.formContext.formStore.getDependentOptions(_this4.props.formContext.descriptions[_this4.props.name], dependentItems).then(function (selectOptions) {
          _this4.setState({
            loading: false,
            selectOptions: selectOptions
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.getComponent();
    }
  }]);

  return OptionsProviderComponent;
}(React.Component);
/**
 * We need form context and values inside the provider component to decide on whether to re-render the component.
 */


export var OptionsProvider = function OptionsProvider(props) {
  return React.createElement(FormContextConsumer, null, function (formContext) {
    return React.createElement(FormSpy, {
      subscription: {
        values: true
      }
    }, function (_ref5) {
      var values = _ref5.values;
      return React.createElement(OptionsProviderComponent, Object.assign({}, props, {
        formContext: formContext,
        values: values
      }));
    });
  });
};